import React from "react";
import { Navigate, useLocation, useOutlet } from "react-router-dom";
import { localUrlEnum } from "../Utils/UrlEnum";
import { EXCLUDE_ROUTES_FROM_LOGIN_REDIRECT } from "../Utils/Constants";

const PrivateRoute = (props: { children: React.ReactNode }): JSX.Element => {
  const location = useLocation();
  const outlet: any = useOutlet();
  const additionalProp: any = outlet?.props?.children?.props?.children?.props;

  /**
   *
   * @returns
   */
  const isLoggedIn = () => {
    const token = localStorage.getItem("access_token");
    if (
      !token &&
      !EXCLUDE_ROUTES_FROM_LOGIN_REDIRECT.includes(location.pathname)
    ) {
      return false;
    }
    return true;
  };

  /**
   *
   */
  const renderChildrenWithProps: any = () => {
    return React.Children.map(props.children, (child) => {
      if (React.isValidElement(child)) {
        // Clone the child element with additional props
        return React.cloneElement(child, additionalProp);
      }
      return child;
    });
  };

  return isLoggedIn() ? (
    renderChildrenWithProps()
  ) : (
    <Navigate
      replace={true}
      to={localUrlEnum.login}
      state={{ from: `${location.pathname}${location.search}` }}
    />
  );
};

export default PrivateRoute;
